import BaseHandler from './baseHandler';
import { BROKER_SHIPMENT_EVENTS } from './utils';

/**
 * SearchShipmentHandler Class
 * Manages broker shipment search subscriptions using event-based approach (no polling)
 * Specifically for single shipment polling via SEARCH_SHIPMENTS_BROKER event
 */
class SearchShipmentHandler extends BaseHandler {
  constructor(socketClient, config = {}) {
    const events = {
      SEARCH_BROKER_SHIPMENT: config.SEARCH_BROKER_SHIPMENT || BROKER_SHIPMENT_EVENTS.SEARCH_BROKER_SHIPMENT,
      SEARCH_BROKER_SHIPMENT_RESPONSE: config.SEARCH_BROKER_SHIPMENT_RESPONSE || BROKER_SHIPMENT_EVENTS.SEARCH_BROKER_SHIPMENT_RESPONSE,
      DISCONNECT: config.DISCONNECT || BROKER_SHIPMENT_EVENTS.DISCONNECT,
    };
    
    super(socketClient, events, 'SearchShipmentHandler');
    this.currentToken = null;
  }

  /**
   * Starts listening to broker shipment search updates for a single shipment
   */
  startListening(shipmentId, token, callback) {
    this.stopListening();

    if (!shipmentId || !token) {
      console.warn(`[${this.handlerName}] Cannot start listening: shipmentId or token missing`);
      return;
    }

    if (!this._checkConnection('start listening')) {
      return;
    }

    this.currentShipmentId = shipmentId;
    this.currentToken = token;
    this.callback = callback;

    // Build the search filters for single shipment
    const eventMessage = {
      searchType: "SEARCH_TYPE_BROKER",
      filters: [
        {
          key: "SEARCH_FILTERS_SHIPMENT_ID",
          value: shipmentId
        }
      ],
      token: token
    };

    // Add LVS flag if needed
    if (typeof window !== 'undefined' && window.shipmentMode === 'LVS_SHIPMENTS') {
      eventMessage.isLvs = true;
    }

    // Emit event to backend to start monitoring
    this._emitEvent(this.events.SEARCH_BROKER_SHIPMENT, {shipmentId, token});

    // Subscribe to broker shipment response events
    this.unsubscribe = this._subscribe(
      this.events.SEARCH_BROKER_SHIPMENT_RESPONSE,
      shipmentId,
      callback
    );

    console.log(`[${this.handlerName}] Started listening for shipment: ${shipmentId}`);
  }

  /**
   * Stops listening to broker shipment search updates
   */
  stopListening() {
    this._cleanup();
    this.currentToken = null;
    console.log(`[${this.handlerName}] Stopped listening`);
  }
}

export default SearchShipmentHandler;
